import React from "react";
import FormattedAchievementResult from '../../Common/Achievements/FormattedAchievementResult.jsx'
const TeamDetailsTableAchievements = ({team, achievements}) => {
    if (!achievements) {
        return null;
    }

    return <table className="zw-tbl team-details__achievements">
        <thead>
        <tr>{achievements.map(
            a => <th
                title={a.name}
                key={a.id}>
                {a.abbr}
            </th>)}
        </tr>
        </thead>
        <Rows
            details={team.mainSquad}
            achievements={achievements}
        />
        <Rows
            skipTitle
            details={team.substitutes}
            achievements={achievements}
        />
        <Predictions
            predictions={team.predictions}
            teamTimeTrial={team.teamTimeTrial}
            columns={achievements}
        />
        <TotalRow
            achievements={achievements}
        />

    </table>
};

const Predictions = ({predictions, teamTimeTrial, columns}) => {
    if (!predictions) {
        return null;
    }
    return <tbody className="predictions-row">
    <NullRow title columns={columns}/>
    {predictions.map((prediction, i) => <NullRow key={i} columns={columns}/>)}
    {teamTimeTrial ? <NullRow columns={columns}/> : null}
    </tbody>
};

const NullRow = ({columns, title}) => {
    if (title) {
        return <tr>
            {columns.map((col, i)=><th key={i} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>)}
        </tr>
    }
    return <tr>
        {columns.map((col, i)=><td key={i} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>)}
    </tr>
};


const Rows = ({details, skipTitle, achievements}) => {
    if (!details) {
        return null
    }
    return <tbody className="achievement-rows">
    {skipTitle && <NullRow title columns={achievements}/> || null}
    {details.map(
        (detail, i)=> <tr key={i}>
            {achievements.map(
                (achievement, j) => <FormattedAchievementResult
                    key={j}
                    Component="td"
                    achievement={achievement}
                    result={detail.achievements.find(e => e.achievementId === achievement.id)}
                />
            )}
        </tr>)}
    </tbody>;
};

const TotalRow = ({achievements}) => {

    return achievements && <tbody className="total-row">
        <NullRow title columns={achievements}/>
        <NullRow columns={achievements}/>
        <NullRow columns={achievements}/>
        </tbody> || null;
};

export default TeamDetailsTableAchievements;